import { TileState } from "../../../pillar/dashboard/store/state/TileState";
import { LookupModel } from "../../../common/models/LookupModel";
import { UserListModel } from "../../models/UserListModel";
import { UserModel } from "../../models/UserModel";
import { UserAccountDetailedStatusModel } from '../../models/UserAccountDetailedStatusModel';

export class UserState extends TileState<UserListModel, UserModel> {
  public groupLookups: LookupModel[] = [];
  public notificationTypes: LookupModel[] = [];
  public selectedUserAssociatedSubmittingEntities: LookupModel[] = [];
  public globalLockStatus: boolean = undefined;
  public status: UserAccountDetailedStatusModel = new UserAccountDetailedStatusModel();
}



// WEBPACK FOOTER //
// ./src/app/customer/store/state/UserState.ts